import { createRoot, Root } from 'react-dom/client'
import type { OnRenderClientAsync, PageContextClient } from 'vike/types'

import { PageShell } from './PageShell'

let root: Root | undefined

export const onRenderClient: OnRenderClientAsync = async (
  ctx: PageContextClient,
  // eslint-disable-next-line @typescript-eslint/require-await
) => {
  const { Page, pageProps } = ctx

  if (!Page) throw new Error('pageContext.Page is undefined')

  const PageComp = Page as React.ComponentType<typeof pageProps>

  const container = document.getElementById('root')!
  if (!root) root = createRoot(container)

  root.render(
    <PageShell pageContext={ctx}>
      { }
      <PageComp {...pageProps} />
    </PageShell>,
  )
}
